import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Make Pusher available globally for Laravel Echo
window.Pusher = Pusher;

let echoInstance = null;
let echoAuthToken = null;

export const initializeEcho = (authToken) => {
  if (echoInstance && echoAuthToken === authToken) {
    return echoInstance;
  }

  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }

  const wsScheme = import.meta.env.VITE_BROADCASTER_SCHEME || 'http';
  const appKey = import.meta.env.VITE_BROADCASTER_APP_KEY || 'doctolik-app-key';
  const broadcaster = import.meta.env.VITE_BROADCASTER_DRIVER || 'pusher';
  const cluster = import.meta.env.VITE_BROADCASTER_APP_CLUSTER || 'eu';

  echoInstance = new Echo({
    broadcaster: broadcaster,
    key: appKey,
    cluster: cluster,
    forceTLS: wsScheme === 'https',
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authEndpoint: `${import.meta.env.VITE_BROADCASTER_AUTH_ENDPOINT}`,
    auth: {
      headers: {
        Authorization: `Bearer ${authToken || ''}`,
        Accept: 'application/json',
      },
    },
  });

  echoAuthToken = authToken;
  return echoInstance;
};

export const getEchoInstance = () => {
  return echoInstance;
};

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }

  echoAuthToken = null;
};

// Assistant Chat Events
export const subscribeToAssistantChat = (doctorId, callbacks) => {
  if (!echoInstance) {
    console.error('Echo not initialized. Call initializeEcho first.');
    return null;
  }

  const channel = echoInstance.private(`doctor.${doctorId}.channel`);

  console.log(`Subscribed to channel: doctor.${doctorId}.channel`);

  if (callbacks.onMessageSent) {
    console.log("Subscribing to message sent event");
    channel.listen('.assistant-chat.message.sent', callbacks.onMessageSent);
  }

  if (callbacks.onMessageRead) {
    console.log("Subscribing to message read event");
    channel.listen('.assistant-chat.message.read', callbacks.onMessageRead);
  }

  if (callbacks.onMemberAdded) {
    console.log("Subscribing to member added event");
    channel.listen('.assistant-chat.member.added', callbacks.onMemberAdded);
  }

  if (callbacks.onMemberRemoved) {
    console.log("Subscribing to member removed event");
    channel.listen('.assistant-chat.member.removed', callbacks.onMemberRemoved);
  }

  return channel;
};

export const unsubscribeFromAssistantChat = (doctorId) => {
  if (echoInstance) {
    echoInstance.leave(`doctor.${doctorId}.channel`);
  }
};
